import { NotiApi } from 'api/ApiHelper';
import { notiQueryKey } from 'queries/noti/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetInboxProfileNotiUnreadCountQuery = () =>
  useQuery({ queryKey: notiQueryKey.profileUnreadCount(), queryFn: () => NotiApi.getInboxProfileNotiUnreadCount() });
